// adminfrontend/src/admin_ui/services/adminUsersApi.js
import adminApi from "./adminApiClient";

const adminUsersApi = {
  async getLookups() {
    const r = await adminApi.get("/api/admin/users/lookups");
    return r.data;
  },

  async listUsers(params = {}) {
    const r = await adminApi.get("/api/admin/users", { params });
    return r.data;
  },

  async listDeletedUsers(params = {}) {
    const r = await adminApi.get("/api/admin/users/deleted", { params });
    return r.data;
  },

  async createUser(payload) {
    const r = await adminApi.post("/api/admin/users", payload);
    return r.data;
  },

  async resetPassword(userId, payload) {
    const r = await adminApi.post(`/api/admin/users/${userId}/reset-password`, payload);
    return r.data;
  },

  async updateStatus(userId, payload) {
    const r = await adminApi.patch(`/api/admin/users/${userId}/status`, payload);
    return r.data;
  },

  async softDeleteUser(userId) {
    const r = await adminApi.delete(`/api/admin/users/${userId}`);
    return r.data;
  },

  async restoreUser(userId) {
    const r = await adminApi.post(`/api/admin/users/${userId}/restore`);
    return r.data;
  },

  async permanentDeleteUser(userId) {
    const r = await adminApi.delete(`/api/admin/users/${userId}/permanent`);
    return r.data;
  },
};

export default adminUsersApi;
